import type { NotificationProvider, OpenNotificationParams } from "@refinedev/core";

export interface AppNotification extends OpenNotificationParams { key: string }
const eventName = "trading-app-notification";

export const notificationProvider: NotificationProvider = {
  open: (params) => {
    const detail: AppNotification = { ...params, key: params.key ?? `notice-${Date.now()}` };
    window.dispatchEvent(new CustomEvent(eventName, { detail }));
  },
  close: (key) => {
    window.dispatchEvent(new CustomEvent(`${eventName}-close`, { detail: key }));
  },
};

export const notificationEventName = eventName;
